var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.79,
    cy: 92.32,
    rx: 37.01,
    ry: 31.41,
    transform: "translate(474.95 678.95) rotate(-87.71)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.64,93.35c-.89,18.6-13.3,33.4-28.61,35.21a26.46,26.46,0,0,0,5,.72c17.33.89,32.17-14.94,33.15-35.36s-12.27-37.68-29.6-38.57a27.31,27.31,0,0,0-4.53.15C602.84,59.09,613.52,74.94,612.64,93.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.68,
    cy: 437.5,
    rx: 37,
    ry: 17.95,
    transform: "translate(-40.9 37.73) rotate(-5.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,450c-18.56,1.47-34-4-36.74-12.53a9.36,9.36,0,0,0-.42,2.91c.17,9.94,16.8,16.7,37.16,15.09s36.74-10.95,36.57-20.89a8.81,8.81,0,0,0-.43-2.56C399.45,440.83,384.34,448.58,366,450Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87,
    cy: 378.78,
    rx: 24.45,
    ry: 28.8,
    transform: "translate(-222.93 144.29) rotate(-39.95)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,389.8c9.4,11,24.08,14.26,34.37,8.09a21.35,21.35,0,0,1-2.73,2.82c-10.25,8.78-26.92,6.09-37.23-6s-10.36-29.05-.11-37.83a21,21,0,0,1,2.87-2.06C63.78,364,64.73,378.88,74,389.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.32,
    cy: 254.17,
    rx: 18.78,
    ry: 12.84,
    transform: "translate(-197.66 307.75) rotate(-89.16)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.39,253.86c-.21,9.45,4.4,17.42,10.58,18.91a8.74,8.74,0,0,1-2,.18c-7.09-.21-12.66-8.79-12.43-19.16s6.15-18.61,13.24-18.4a8.68,8.68,0,0,1,1.84.25C53.43,236.89,48.59,244.51,48.39,253.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.61,338.39c-5.37,10.14-2.74,22.05,5.89,26.58s20,0,25.35-10.15,2.74-22.05-5.88-26.59S665,328.24,659.61,338.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.09,352.37c4.9-9.25,3.14-20-3.74-25.22a15.56,15.56,0,0,1,2.62,1.08c8.62,4.54,11.26,16.44,5.88,26.59S674.12,369.51,665.5,365a14.81,14.81,0,0,1-2.15-1.37C671.53,366.11,681.24,361.52,686.09,352.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.82,
    cy: 83.84,
    rx: 28.8,
    ry: 24.45,
    transform: "translate(45.2 231.44) rotate(-70.67)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.9,77.4c-4.69,13.71,0,28,10.6,33.67a21.49,21.49,0,0,1-3.81-.9c-12.79-4.33-19-20-13.84-35.09s19.68-23.74,32.47-19.42a22.34,22.34,0,0,1,3.24,1.41C184.81,55.42,172.54,63.82,167.9,77.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.51,82.53l4.21,2.5a.81.81,0,0,1-.08,1.42l-4.46,2.23a.85.85,0,0,0-.34.31l-2.61,4.26a.81.81,0,0,1-1.42,0l-2.13-4.4a.76.76,0,0,0-.31-.33L508.17,86a.81.81,0,0,1,.08-1.42l4.46-2.23a.85.85,0,0,0,.34-.31l2.6-4.25a.82.82,0,0,1,1.43,0l2.13,4.4A.83.83,0,0,0,519.51,82.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,444.41l4.21,2.5a.81.81,0,0,1-.08,1.42l-4.46,2.23a.85.85,0,0,0-.34.31l-2.61,4.26a.81.81,0,0,1-1.42-.05l-2.13-4.4a.82.82,0,0,0-.31-.33l-4.2-2.5a.81.81,0,0,1,.08-1.42l4.46-2.24a.78.78,0,0,0,.34-.31l2.6-4.25a.81.81,0,0,1,1.42,0l2.14,4.41A.79.79,0,0,0,112.62,444.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.76,441.44l4.21,2.5a.81.81,0,0,1-.08,1.42l-4.46,2.24a.78.78,0,0,0-.34.31l-2.61,4.25a.81.81,0,0,1-1.42,0l-2.13-4.41a.82.82,0,0,0-.31-.33l-4.2-2.5a.81.81,0,0,1,.08-1.42l4.46-2.23a.85.85,0,0,0,.34-.31l2.6-4.26a.82.82,0,0,1,1.43,0l2.13,4.4A.8.8,0,0,0,483.76,441.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.92,437.83l4.2,2.51a.8.8,0,0,1-.07,1.41L666.58,444a.84.84,0,0,0-.34.31l-2.6,4.25a.81.81,0,0,1-1.42,0l-2.14-4.4a.76.76,0,0,0-.3-.34l-4.2-2.5a.81.81,0,0,1,.07-1.42l4.46-2.23a.85.85,0,0,0,.34-.31l2.61-4.26a.81.81,0,0,1,1.42.05l2.14,4.4A.74.74,0,0,0,666.92,437.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21,131l4.2,2.5a.81.81,0,0,1-.07,1.42l-4.47,2.24a.84.84,0,0,0-.34.31l-2.6,4.25a.81.81,0,0,1-1.42,0l-2.14-4.41a.79.79,0,0,0-.3-.33l-4.2-2.5a.81.81,0,0,1,.07-1.42l4.47-2.23a.89.89,0,0,0,.33-.31l2.61-4.26a.81.81,0,0,1,1.42,0l2.14,4.4A.74.74,0,0,0,218.21,131Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.06,46.53l4.2,2.5a.81.81,0,0,1-.08,1.42l-4.46,2.24a.78.78,0,0,0-.34.31l-2.6,4.25a.82.82,0,0,1-1.43,0l-2.13-4.41a.86.86,0,0,0-.3-.33L233.71,50a.81.81,0,0,1,.08-1.42l4.46-2.23a.85.85,0,0,0,.34-.31l2.61-4.26a.81.81,0,0,1,1.42,0l2.13,4.4A.76.76,0,0,0,245.06,46.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,83.32,111,84.59a.41.41,0,0,1,0,.72l-2.26,1.14a.41.41,0,0,0-.17.15l-1.32,2.16a.42.42,0,0,1-.73,0l-1.08-2.23a.41.41,0,0,0-.15-.17l-2.14-1.27a.41.41,0,0,1,0-.72l2.27-1.14a.41.41,0,0,0,.17-.15l1.32-2.16a.41.41,0,0,1,.72,0l1.09,2.23A.35.35,0,0,0,108.88,83.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.69,71l2.13,1.27a.41.41,0,0,1,0,.72l-2.26,1.13a.37.37,0,0,0-.17.16L345,76.44a.41.41,0,0,1-.72,0l-1.08-2.23a.41.41,0,0,0-.15-.17l-2.14-1.27a.41.41,0,0,1,0-.72l2.27-1.13a.44.44,0,0,0,.17-.16l1.32-2.16a.41.41,0,0,1,.72,0l1.08,2.24A.44.44,0,0,0,346.69,71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.51,57l2.14,1.27a.41.41,0,0,1,0,.72l-2.27,1.13a.44.44,0,0,0-.17.16l-1.32,2.16a.41.41,0,0,1-.72,0l-1.08-2.24a.44.44,0,0,0-.16-.17l-2.13-1.27a.41.41,0,0,1,0-.72l2.26-1.13a.37.37,0,0,0,.17-.16l1.33-2.16a.41.41,0,0,1,.72,0l1.08,2.23A.41.41,0,0,0,544.51,57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.13,63.9l2.13,1.27a.41.41,0,0,1,0,.72L681,67a.44.44,0,0,0-.17.16l-1.32,2.16a.42.42,0,0,1-.73,0l-1.08-2.24a.41.41,0,0,0-.15-.17l-2.14-1.27a.41.41,0,0,1,0-.72l2.27-1.13a.37.37,0,0,0,.17-.16l1.32-2.16a.41.41,0,0,1,.72,0L681,63.73A.35.35,0,0,0,681.13,63.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,462.83l2.5,1.46a.49.49,0,0,1,0,.85l-2.63,1.34a.52.52,0,0,0-.2.19l-1.52,2.53a.49.49,0,0,1-.85,0l-1.28-2.6a.55.55,0,0,0-.18-.19l-2.51-1.46a.48.48,0,0,1,0-.84l2.63-1.35a.49.49,0,0,0,.2-.18l1.52-2.54a.49.49,0,0,1,.85,0l1.28,2.6A.44.44,0,0,0,436.94,462.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.43,281.56l2.51,1.46a.48.48,0,0,1,0,.84l-2.63,1.35a.46.46,0,0,0-.2.19l-1.52,2.53a.49.49,0,0,1-.85,0l-1.28-2.6a.44.44,0,0,0-.19-.19l-2.5-1.46a.48.48,0,0,1,0-.84l2.63-1.35a.52.52,0,0,0,.2-.19l1.52-2.53a.49.49,0,0,1,.85,0l1.28,2.6A.47.47,0,0,0,698.43,281.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.05,303.82l2,1.19a.39.39,0,0,1,0,.68l-2.14,1.07a.46.46,0,0,0-.16.15l-1.25,2a.39.39,0,0,1-.68,0l-1-2.11a.46.46,0,0,0-.15-.16l-2-1.2a.39.39,0,0,1,0-.68l2.14-1.07a.33.33,0,0,0,.16-.15l1.25-2a.38.38,0,0,1,.68,0l1,2.11A.57.57,0,0,0,53.05,303.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.69,452.52l2,1.2a.39.39,0,0,1,0,.68l-2.14,1.07a.39.39,0,0,0-.16.15l-1.25,2a.39.39,0,0,1-.68,0l-1-2.11a.46.46,0,0,0-.15-.16l-2-1.2a.39.39,0,0,1,0-.68l2.14-1.07a.33.33,0,0,0,.16-.15l1.25-2a.39.39,0,0,1,.68,0l1,2.11A.39.39,0,0,0,265.69,452.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.08,403.6l2,1.2a.39.39,0,0,1,0,.68l-2.14,1.07a.39.39,0,0,0-.16.15l-1.25,2a.39.39,0,0,1-.68,0l-1-2.11a.36.36,0,0,0-.14-.16l-2-1.2a.39.39,0,0,1,0-.68l2.14-1.07a.33.33,0,0,0,.16-.15l1.25-2a.39.39,0,0,1,.68,0l1,2.1A.39.39,0,0,0,649.08,403.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.54,451.1l2,1.2a.39.39,0,0,1,0,.68l-2.14,1.07a.33.33,0,0,0-.16.15l-1.25,2a.39.39,0,0,1-.68,0l-1-2.11a.43.43,0,0,0-.15-.15l-2-1.2a.39.39,0,0,1,0-.68l2.14-1.07a.46.46,0,0,0,.16-.15l1.25-2a.39.39,0,0,1,.68,0l1,2.11A.46.46,0,0,0,606.54,451.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.55,145.17l2.18,1.3a.42.42,0,0,1,0,.73l-2.32,1.16a.44.44,0,0,0-.17.16l-1.36,2.21a.42.42,0,0,1-.73,0L646,148.42a.37.37,0,0,0-.16-.17l-2.18-1.3a.42.42,0,0,1,0-.74l2.32-1.15a.46.46,0,0,0,.17-.17l1.35-2.2a.42.42,0,0,1,.74,0l1.11,2.28A.35.35,0,0,0,649.55,145.17Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.76,183.21l1,.65a.19.19,0,0,1,0,.34l-1.06.51a.16.16,0,0,0-.08.08l-.6,1a.2.2,0,0,1-.35,0l-.55-1.09a.2.2,0,0,0-.08-.08l-1-.65a.19.19,0,0,1,0-.34l1.07-.51a.2.2,0,0,0,.08-.08l.6-1a.19.19,0,0,1,.34,0l.56,1.09A.18.18,0,0,0,579.76,183.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.58,334.37l1,.65a.19.19,0,0,1,0,.34l-1.06.51a.15.15,0,0,0-.08.08l-.6,1a.2.2,0,0,1-.35,0l-.55-1.09a.3.3,0,0,0-.08-.08l-1-.64a.2.2,0,0,1,0-.35l1.07-.51a.27.27,0,0,0,.08-.07l.59-1a.2.2,0,0,1,.35,0l.55,1.09A.3.3,0,0,0,580.58,334.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.11,265.1l2,1.2a.39.39,0,0,1,0,.68L622,268.05a.41.41,0,0,0-.17.15l-1.24,2a.39.39,0,0,1-.68,0l-1-2.1a.36.36,0,0,0-.14-.16l-2-1.2a.39.39,0,0,1,0-.68l2.14-1.07a.33.33,0,0,0,.16-.15l1.25-2a.39.39,0,0,1,.68,0l1,2.11A.31.31,0,0,0,622.11,265.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.6,194.53l2,1.25a.38.38,0,0,1,0,.67l-2.07,1a.46.46,0,0,0-.16.15l-1.16,2a.39.39,0,0,1-.68,0l-1.07-2.13a.46.46,0,0,0-.15-.16l-2-1.25a.39.39,0,0,1,0-.68l2.08-1a.34.34,0,0,0,.15-.14l1.17-2a.38.38,0,0,1,.67,0l1.08,2.12A.39.39,0,0,0,568.6,194.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,253.35l1.53,1a.29.29,0,0,1,0,.51l-1.59.74a.25.25,0,0,0-.12.11l-.91,1.49a.29.29,0,0,1-.51,0l-.79-1.62a.37.37,0,0,0-.12-.13l-1.52-1a.3.3,0,0,1,0-.52l1.58-.73a.22.22,0,0,0,.12-.11l.91-1.49a.29.29,0,0,1,.51,0l.8,1.62A.35.35,0,0,0,93.52,253.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,288l1.48.85a.27.27,0,0,1,0,.48l-1.46.76a.29.29,0,0,0-.11.11l-.78,1.44a.28.28,0,0,1-.49,0l-.82-1.49a.25.25,0,0,0-.11-.12l-1.47-.84a.27.27,0,0,1,0-.48l1.46-.76a.38.38,0,0,0,.11-.11l.78-1.44a.27.27,0,0,1,.48,0l.82,1.49A.29.29,0,0,0,126.64,288Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.94,173.31l1.48.85a.28.28,0,0,1,0,.48l-1.46.76a.22.22,0,0,0-.11.1l-.79,1.45a.27.27,0,0,1-.48,0l-.82-1.5a.29.29,0,0,0-.11-.11l-1.48-.84a.28.28,0,0,1,0-.49l1.46-.76a.24.24,0,0,0,.1-.1l.79-1.45a.27.27,0,0,1,.48,0l.82,1.49A.57.57,0,0,0,170.94,173.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,149l1.48.85a.27.27,0,0,1,0,.48l-1.46.76a.2.2,0,0,0-.11.11l-.79,1.44a.27.27,0,0,1-.48,0l-.82-1.49a.25.25,0,0,0-.11-.12l-1.48-.84a.27.27,0,0,1,0-.48l1.46-.76a.38.38,0,0,0,.11-.11l.78-1.45a.28.28,0,0,1,.48,0l.82,1.49A.29.29,0,0,0,285.88,149Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,293.52l2.93,1.68a.55.55,0,0,1,0,1l-2.89,1.51a.5.5,0,0,0-.22.21l-1.56,2.87a.54.54,0,0,1-1,0l-1.63-3a.61.61,0,0,0-.22-.23l-2.94-1.68a.54.54,0,0,1,0-1l2.9-1.51a.53.53,0,0,0,.21-.21l1.56-2.87a.55.55,0,0,1,1,0l1.63,3A.58.58,0,0,0,115.84,293.52Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,133.66l2.93,1.68a.54.54,0,0,1,0,.95l-2.89,1.51a.56.56,0,0,0-.22.21l-1.56,2.87a.54.54,0,0,1-.95,0l-1.63-3a.58.58,0,0,0-.22-.22L299.14,136a.55.55,0,0,1,0-1l2.9-1.51a.47.47,0,0,0,.21-.21l1.56-2.87a.55.55,0,0,1,1,0l1.63,3A.61.61,0,0,0,306.61,133.66Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.68,419l2.93,1.68a.54.54,0,0,1,0,.95l-2.9,1.51a.47.47,0,0,0-.21.21L263,426.22a.55.55,0,0,1-1,0l-1.63-3a.58.58,0,0,0-.22-.22l-2.93-1.68a.55.55,0,0,1,0-1l2.9-1.51a.5.5,0,0,0,.22-.21l1.56-2.87a.54.54,0,0,1,.95,0l1.63,3A.61.61,0,0,0,264.68,419Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.67,366.86l2.93,1.68a.55.55,0,0,1,0,1L537.72,371a.56.56,0,0,0-.22.21l-1.56,2.87a.54.54,0,0,1-1,0l-1.63-3a.58.58,0,0,0-.22-.22l-2.94-1.68a.55.55,0,0,1,0-1l2.9-1.51a.47.47,0,0,0,.21-.21l1.56-2.87a.55.55,0,0,1,1,0l1.63,3A.52.52,0,0,0,537.67,366.86Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.32,149.69l1.91,1.1a.35.35,0,0,1,0,.62l-1.89,1a.38.38,0,0,0-.14.14l-1,1.87a.36.36,0,0,1-.63,0l-1.06-1.93a.32.32,0,0,0-.14-.14l-1.91-1.1a.35.35,0,0,1,0-.62l1.89-1a.32.32,0,0,0,.14-.14l1-1.87a.36.36,0,0,1,.63,0l1.06,1.93A.32.32,0,0,0,497.32,149.69Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-4--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.96,
    cy: 410.96,
    rx: 42.83,
    ry: 27.51,
    transform: "translate(-127.9 497.57) rotate(-43.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.15,424.85c-15.73,14.74-35.76,19.47-47.06,11.8a17.49,17.49,0,0,0,2.61,3.57c10.4,11.08,32.83,6.95,50.1-9.21s22.83-38.25,12.43-49.32a17.75,17.75,0,0,0-3-2.58C601.78,390.9,595.72,410.28,580.15,424.85Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-3--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.34,
    cy: 92.59,
    rx: 22.72,
    ry: 11.58,
    transform: "translate(-14.76 87.73) rotate(-17.22)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.53,85c10.87-3.52,21.35-2.38,24.78,2.4a6.13,6.13,0,0,0-.36-1.83c-2.19-6-13.64-7.76-25.58-3.89s-19.83,11.88-17.64,17.89a6.55,6.55,0,0,0,.8,1.5C261.29,95.36,268.77,88.51,279.53,85Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-2--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.51,
    cy: 136.24,
    rx: 22.03,
    ry: 57.53,
    transform: "translate(217.53 526.13) rotate(-81.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.34,121.31c28.53,4.86,50,16.84,51.21,27.88a9.65,9.65,0,0,0,1.63-3.29c3.14-11.82-19.68-25.73-51-31.06s-59.22-.08-62.37,11.74a9,9,0,0,0-.23,3.18C365.65,120.31,391.12,116.5,419.34,121.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,134.36c7.17,3.75,12,10.83,18.63,15.45,4.4,3.05,9.74,5.16,12.7,9.62-.29-2.61-2.08-4.78-3.86-6.71a98.24,98.24,0,0,0-16.77-14.43c-3.14-2.13-6.62-4.15-10.41-4.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.08,134.36c7.17,3.75,12,10.83,18.63,15.45,4.4,3.05,9.74,5.16,12.7,9.62-.29-2.61-2.08-4.78-3.86-6.71a98.24,98.24,0,0,0-16.77-14.43c-3.14-2.13-6.62-4.15-10.41-4.13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,37.58a5.6,5.6,0,0,0-1.13-3.25c-1.08-1.19-2.89-1.31-4.49-1.19-6.82.51-15.5,10.62-19.67,16l.7,30.09C441.29,69.49,448.8,52,447.2,37.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M447.2,37.58a5.6,5.6,0,0,0-1.13-3.25c-1.08-1.19-2.89-1.31-4.49-1.19-6.82.51-15.5,10.62-19.67,16l.7,30.09C441.29,69.49,448.8,52,447.2,37.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,99.38a67.86,67.86,0,0,1,10.7-2.86c3.56-.58,7.13-2.07,10.64-2.9,4.54-1.06,8.78-3.11,13.14-4.79s9-3,13.65-2.48A24.74,24.74,0,0,0,454.62,84a74.63,74.63,0,0,0-11.44,1.21c-5.26.84-10.62,1.71-15.38,4.1s-9.15,4.83-10.14,10.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.66,99.38a67.86,67.86,0,0,1,10.7-2.86c3.56-.58,7.13-2.07,10.64-2.9,4.54-1.06,8.78-3.11,13.14-4.79s9-3,13.65-2.48A24.74,24.74,0,0,0,454.62,84a74.63,74.63,0,0,0-11.44,1.21c-5.26.84-10.62,1.71-15.38,4.1s-9.15,4.83-10.14,10.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,100.4c-4.61-6.76-13.85-8.73-21.8-10.7a194.26,194.26,0,0,1,29.65,31.94C403.12,116.14,399.27,109,393.43,100.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.43,100.4c-4.61-6.76-13.85-8.73-21.8-10.7a194.26,194.26,0,0,1,29.65,31.94C403.12,116.14,399.27,109,393.43,100.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M399.39,142.39c-9.51-2.75-17.35-13.61-26.73-16.67,10.82-.51,24.35,6,26.73,16.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M399.39,142.39c-9.51-2.75-17.35-13.61-26.73-16.67,10.82-.51,24.35,6,26.73,16.67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M408.86,120.44a32.23,32.23,0,0,1,15.54,3.11,97.07,97.07,0,0,1,13.81,8.1c.41-3.44-1.6-6.66-3.52-9.55a41.26,41.26,0,0,0-4.74-6.23,13.77,13.77,0,0,0-6.62-4,11.73,11.73,0,0,0-9,1.84,13.62,13.62,0,0,0-5.46,6.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.11,155.48s4.72-32.25,9.95-50,10.3-38,10.3-38l2.06.56s-11,35.13-15.34,57-2.87,31.61-2.87,31.61l-4.1-1.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.28,35.32a1.82,1.82,0,0,1-.22.33l-.68.91c-.6.77-1.45,1.91-2.49,3.33-2.08,2.83-4.83,6.83-7.57,11.43s-4.93,8.94-6.42,12.12c-.75,1.59-1.34,2.88-1.74,3.78-.19.42-.34.76-.47,1a1.51,1.51,0,0,1-.18.35,1.8,1.8,0,0,1,.12-.37c.1-.28.24-.63.41-1.06.35-.92.91-2.23,1.63-3.83a122.44,122.44,0,0,1,14-23.6c1.06-1.4,1.95-2.52,2.58-3.27.3-.35.54-.64.74-.86S445.27,35.31,445.28,35.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.9,83.81a26.16,26.16,0,0,1-5.34-25c1.79-6.16,5.69-11.46,9.75-16.42a2.46,2.46,0,0,1,1.3-1,2.31,2.31,0,0,1,2,1c4.44,5,5.72,12.18,5.4,18.88a32.4,32.4,0,0,1-3.05,12.95,22,22,0,0,1-10,9.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.9,83.81a2.15,2.15,0,0,1,.1-.38c.09-.28.2-.63.34-1.05.31-.91.73-2.24,1.21-3.89a113.07,113.07,0,0,0,2.93-13.09c.83-5.18,1.32-9.91,1.65-13.33.16-1.68.3-3,.39-4q.08-.68.12-1.11c0-.25.05-.38.07-.38a2,2,0,0,1,0,.39c0,.29,0,.66,0,1.11-.05,1-.14,2.35-.28,4.06-.27,3.43-.71,8.17-1.56,13.37a97,97,0,0,1-3,13.1c-.52,1.65-1,3-1.32,3.86-.16.42-.3.76-.4,1A1.39,1.39,0,0,1,416.9,83.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.86,120.44a32.23,32.23,0,0,1,15.54,3.11,97.07,97.07,0,0,1,13.81,8.1c.41-3.44-1.6-6.66-3.52-9.55a41.26,41.26,0,0,0-4.74-6.23,13.77,13.77,0,0,0-6.62-4,11.73,11.73,0,0,0-9,1.84,13.62,13.62,0,0,0-5.46,6.7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.18,146.71s-.1-.07-.27-.22-.43-.39-.72-.65c-.61-.58-1.49-1.43-2.61-2.44-.55-.51-1.17-1.06-1.85-1.63s-1.39-1.19-2.17-1.81a38.37,38.37,0,0,0-5.32-3.65,13.1,13.1,0,0,0-6.08-1.82,19.78,19.78,0,0,0-2.81.07,14.34,14.34,0,0,0-2.39.51,13.8,13.8,0,0,0-3.22,1.46c-.71.44-1.08.73-1.1.71s.08-.09.25-.24a8.91,8.91,0,0,1,.78-.59,13,13,0,0,1,3.22-1.58,13.45,13.45,0,0,1,2.42-.56,17.77,17.77,0,0,1,2.86-.1,13.27,13.27,0,0,1,6.24,1.83,36.48,36.48,0,0,1,5.36,3.7c.77.64,1.5,1.25,2.16,1.85s1.27,1.14,1.82,1.67c1.1,1,1.95,1.91,2.54,2.52l.67.7A2.07,2.07,0,0,1,432.18,146.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55,135.73a2.16,2.16,0,0,1,.55.33,14.51,14.51,0,0,1,1.37,1.1,19.81,19.81,0,0,1,3.69,4.48,19.42,19.42,0,0,1,2.21,5.35,14.52,14.52,0,0,1,.32,1.73,2,2,0,0,1,0,.65c-.06,0-.2-.9-.6-2.31a21.83,21.83,0,0,0-5.83-9.72C394.25,136.32,393.51,135.78,393.55,135.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,97.22a2.1,2.1,0,0,1,.37.23l1,.72,1.62,1.16c.64.45,1.3,1,2.06,1.66a57.74,57.74,0,0,1,10.28,11.3,62.67,62.67,0,0,1,4.24,7.28,65.57,65.57,0,0,1,2.7,6.34c.67,1.84,1.15,3.35,1.47,4.39.16.49.28.89.38,1.2a2.5,2.5,0,0,1,.11.43,3.21,3.21,0,0,1-.18-.4c-.1-.27-.26-.67-.44-1.19-.36-1-.87-2.52-1.57-4.35s-1.62-4-2.76-6.27a65.22,65.22,0,0,0-4.24-7.23A60.89,60.89,0,0,0,386,101.18c-.75-.62-1.4-1.23-2-1.69l-1.58-1.21-1-.77A2,2,0,0,1,381,97.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.64,119a3.6,3.6,0,0,1-.73-.31l-.84-.4c-.32-.15-.72-.26-1.14-.43a12.36,12.36,0,0,0-6.91-.48,12,12,0,0,0-3.59,1.4,14.36,14.36,0,0,0-2.57,1.85,21.5,21.5,0,0,0-2,2.15,2.82,2.82,0,0,1,.4-.69,10.84,10.84,0,0,1,1.42-1.64,13.14,13.14,0,0,1,2.58-2A12,12,0,0,1,422,117.6c.42.18.82.31,1.14.49l.81.45A3.48,3.48,0,0,1,424.64,119Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.64,87.63a3,3,0,0,1-.42.12L442,88c-1.06.25-2.59.62-4.47,1.14s-4.1,1.2-6.51,2.1a47.75,47.75,0,0,0-7.58,3.49A16,16,0,0,0,420,97.36c-.95,1-1.86,2-2.71,3a65.45,65.45,0,0,0-4.3,5.32,37.83,37.83,0,0,0-2.44,3.9c-.53,1-.77,1.51-.8,1.5a2,2,0,0,1,.15-.42c.11-.26.28-.65.52-1.14a33.38,33.38,0,0,1,2.37-4,59,59,0,0,1,4.25-5.39c.85-1,1.76-2,2.71-3a16.47,16.47,0,0,1,3.49-2.65A46.25,46.25,0,0,1,430.9,91c2.43-.88,4.67-1.53,6.55-2s3.44-.82,4.51-1l1.24-.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.58,115.48a3.13,3.13,0,0,1,0-.85c0-.62,0-1.4,0-2.33a64.41,64.41,0,0,0-.37-7.65,63.69,63.69,0,0,0-1.36-7.54c-.21-.9-.38-1.66-.52-2.26a4.9,4.9,0,0,1-.16-.85,3.67,3.67,0,0,1,.29.81c.16.53.38,1.29.64,2.24a49.51,49.51,0,0,1,1.73,15.26c0,1-.09,1.77-.14,2.32A4.62,4.62,0,0,1,408.58,115.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.33,93.28a26.81,26.81,0,0,0-1-11.11A35.27,35.27,0,0,0,391.39,60Q399,78.32,406.55,96.67l1.64,6.34A17,17,0,0,0,412.33,93.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33,93.28a26.81,26.81,0,0,0-1-11.11A35.27,35.27,0,0,0,391.39,60Q399,78.32,406.55,96.67l1.64,6.34A17,17,0,0,0,412.33,93.28Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-1--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.75,
    cy: 409.91,
    rx: 29.02,
    ry: 45.18,
    transform: "translate(-233.48 255.06) rotate(-44.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.55,424.3c-16.08-16.08-21.75-37-14.07-49.21a19.13,19.13,0,0,0-3.67,2.87c-11.32,11.36-6.19,34.86,11.45,52.51s41.11,22.74,52.42,11.39a18,18,0,0,0,2.62-3.29C214.1,445.92,193.46,440.21,177.55,424.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.54,402.62l14.24-15.17,1.7,1.69s-12,14-12.25,17.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.32 393.88 152.81 423.01 182.37 452.58 211.75 430.17 172.32 393.88",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.56,452.42c-2.67,2.62-11.38-1.94-19.46-10.18s-12.45-17-9.78-19.66,11.38,1.94,19.46,10.18S185.24,449.8,182.56,452.42Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.56,452.42c-2.67,2.62-11.38-1.94-19.46-10.18s-12.45-17-9.78-19.66,11.38,1.94,19.46,10.18S185.24,449.8,182.56,452.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,432.4c-2.44,2.22-14.79.32-28.27-12.08s-21.11-21.73-14.24-29c5.65-6,16.93-1.43,30.41,11S220.65,425.1,212.63,432.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,452.58a5.75,5.75,0,0,1,.48-.41l1.41-1.15,5.41-4.3,19.19-15.09,0,0a3.22,3.22,0,0,0,.42-2.74,12.6,12.6,0,0,0-1-2.95,35,35,0,0,0-3.43-5.64,83.73,83.73,0,0,0-21.65-20,37.15,37.15,0,0,0-6.36-3.2,14.37,14.37,0,0,0-3.24-.85,3.45,3.45,0,0,0-2.9.63l0,0L157.8,415.86l-3.66,5.3-1,1.39a3.58,3.58,0,0,1-.36.46,3.55,3.55,0,0,1,.3-.5l.92-1.43,3.54-5.37,12.73-19h0l0,0a2.76,2.76,0,0,1,1.56-.77,5.83,5.83,0,0,1,1.72,0,15.36,15.36,0,0,1,3.36.86,37.38,37.38,0,0,1,6.45,3.23A83.1,83.1,0,0,1,205.22,420a35.85,35.85,0,0,1,3.47,5.73,13.56,13.56,0,0,1,1,3.07,3.64,3.64,0,0,1-.55,3.14h0l0,0-19.31,14.94-5.49,4.19-1.46,1.1A3.5,3.5,0,0,1,182.37,452.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Texts--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,391.18V396h-17.8V373.85H272.6v4.85H261.42v3.74h9.85v4.69h-9.85v4.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,390.14h-3.43V396h-6.27V373.85h10.14c6.05,0,9.85,3.14,9.85,8.21a7.35,7.35,0,0,1-4.34,7l4.78,7h-6.71Zm.06-11.34h-3.49v6.49h3.49c2.6,0,3.89-1.2,3.89-3.23S288.85,378.8,286.25,378.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.62,390.14H306.2V396h-6.27V373.85h10.14c6.05,0,9.85,3.14,9.85,8.21a7.35,7.35,0,0,1-4.34,7l4.78,7h-6.71Zm.07-11.34H306.2v6.49h3.49c2.6,0,3.89-1.2,3.89-3.23S312.29,378.8,309.69,378.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,384.94c0-6.65,5.23-11.53,12.32-11.53s12.33,4.88,12.33,11.53-5.23,11.53-12.33,11.53S322.23,391.59,322.23,384.94Zm18.31,0c0-3.83-2.63-6.34-6-6.34s-6,2.51-6,6.34,2.62,6.34,6,6.34S340.54,388.77,340.54,384.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,390.14h-3.42V396h-6.27V373.85H360.3c6.05,0,9.86,3.14,9.86,8.21a7.37,7.37,0,0,1-4.34,7l4.78,7h-6.72Zm.06-11.34h-3.48v6.49h3.48c2.6,0,3.9-1.2,3.9-3.23S362.52,378.8,359.92,378.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,382.06c0,5-3.8,8.17-9.85,8.17h-3.87V396H392V373.85h10.14C408.23,373.85,412,377,412,382.06Zm-6.34,0c0-2.06-1.29-3.26-3.89-3.26h-3.49v6.49h3.49C404.4,385.29,405.69,384.09,405.69,382.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,391.72h-9.38L417.7,396h-6.4l9.79-22.18h6.17L437.08,396h-6.52ZM427,387.1l-2.85-7.1-2.85,7.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.4,384.47h5.54v9.18a16.52,16.52,0,0,1-9.31,2.82c-7.07,0-12.23-4.78-12.23-11.53s5.16-11.53,12.35-11.53c4.15,0,7.51,1.43,9.7,4.06l-4,3.61a6.93,6.93,0,0,0-5.39-2.48,6.34,6.34,0,0,0-.06,12.68,8.09,8.09,0,0,0,3.39-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.73,391.18V396h-17.8V373.85h17.39v4.85H469.14v3.74H479v4.69h-9.85v4.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.94,322.7H218.21V296.38L269.39,171.9h30.7V296.38H313.4V322.7H300.09v33.42H271.94Zm0-26.32V224.53h-.51L243.8,296.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.94,322.7H218.21V296.38L269.39,171.9h30.7V296.38H313.4V322.7H300.09v33.42H271.94Zm0-26.32V224.53h-.51L243.8,296.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M259.13,322.7H205.4V296.38L256.57,171.9h30.71V296.38h13.3V322.7h-13.3v33.42H259.13Zm0-26.32V224.53h-.51L231,296.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89,346.65q-11-12.11-11-34.22V215.59q0-22.11,11-34.22t31.73-12.1q20.73,0,31.73,12.1t11,34.22v96.84q0,22.11-11,34.22t-31.73,12.1Q346.89,358.75,335.89,346.65Zm46.31-32.37V213.74q0-18.15-14.58-18.15T353,213.74V314.28q0,18.15,14.59,18.15T382.2,314.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M399.35,181.37q-11-12.09-31.73-12.1t-31.73,12.1q-11,12.12-11,34.22v96.84q0,22.11,11,34.22t31.73,12.1q20.73,0,31.73-12.1t11-34.22V215.59Q410.35,193.48,399.35,181.37ZM382.2,314.28q0,18.15-14.58,18.15c-9.72,0-14.59-7.59-14.59-18.15V213.74c0-11,4.87-18.15,14.59-18.15s14.58,6,14.58,18.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.08,346.65q-11-12.11-11-34.22V215.59q0-22.11,11-34.22t31.72-12.1q20.73,0,31.73,12.1t11,34.22v96.84q0,22.11-11,34.22t-31.73,12.1Q334.09,358.75,323.08,346.65Zm46.31-32.38V213.74q0-18.15-14.59-18.15t-14.58,18.15V314.27q0,18.17,14.58,18.16T369.39,314.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.2,322.7H419.47V296.38L470.64,171.9h30.71V296.38h13.3V322.7h-13.3v33.42H473.2Zm0-26.32V224.54h-.51l-27.64,71.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M473.2,322.7H419.47V296.38L470.64,171.9h30.71V296.38h13.3V322.7h-13.3v33.42H473.2Zm0-26.32V224.54h-.51l-27.64,71.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,322.7H406.65V296.38L457.83,171.9h30.7V296.38h13.31V322.7H488.53v33.42H460.39Zm0-26.32V224.53h-.52l-27.63,71.85Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-part-2--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 547.59,
    cy: 251.75,
    rx: 24.39,
    ry: 76.42,
    transform: "translate(-38.97 113.27) rotate(-11.41)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.28,248.57c-7.61-37.71-22.8-67.11-35.43-70a8.58,8.58,0,0,1,3.63-1.73c13.2-2.66,30.67,28.72,39,70.09s4.41,77.07-8.8,79.73a8.43,8.43,0,0,1-3.6-.08C569.34,318.56,571.8,285.87,564.28,248.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.23,177.27l14.14-20.65s25.74,7.44,28.72,3.88l-39-28.86L676.69,162.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.05,149.39a2,2,0,0,1,.24-2.64,1.9,1.9,0,0,1,2.61.22,2.09,2.09,0,0,1-.27,2.79,2,2,0,0,1-2.69-.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.05,131.64l-2.23,3.24,38.27,26.46s2.3.53,3-.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.86,157.29c.13-.2-.76-1-1.24-2.3s-.39-2.48-.62-2.53-.77,1.26-.15,2.83S710.77,157.49,710.86,157.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.21,158.62c.18-.15-.41-1.09-.46-2.37s.39-2.28.19-2.41-1.11.86-1,2.45S716.07,158.8,716.21,158.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.16,155.44c-.15-.17-1.12.58-1.4,2s.3,2.48.5,2.38.06-1.06.31-2.21S722.33,155.6,722.16,155.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.11,161.63c0-.23-1-.61-2-1.48s-1.61-1.83-1.83-1.74.08,1.36,1.3,2.37S707.1,161.85,707.11,161.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.66,261.18l14.27-20.56s25.69,7.6,28.7,4l-38.88-29.09L663.21,246.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.65,233.31a2,2,0,0,1,.26-2.63,1.9,1.9,0,0,1,2.61.23,2.1,2.1,0,0,1-.29,2.79,2,2,0,0,1-2.69-.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.75,215.58l-2.25,3.23,38.12,26.69s2.29.54,3-.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.41,241.29c.14-.19-.75-1-1.23-2.3s-.37-2.48-.6-2.54-.77,1.26-.17,2.83S697.32,241.49,697.41,241.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.75,242.66c.18-.16-.4-1.09-.44-2.38s.4-2.27.21-2.41-1.12.85-1,2.45S702.61,242.83,702.75,242.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.72,239.51c-.14-.17-1.12.58-1.41,2s.29,2.49.49,2.39.06-1.07.32-2.22S708.89,239.67,708.72,239.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.64,245.62c.05-.24-1-.63-2-1.5s-1.6-1.84-1.82-1.75.08,1.36,1.29,2.38S693.62,245.83,693.64,245.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.39,276.08c1.33,0,119.91-34.16,128.16-41.58s41.93-66.18,41.93-66.18l-23.92-19.5L640,203l-73,6.59s-30.78-2.1-36.14,8.91L530.3,235Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.39,276.08c1.76.05,54.73,59,71.32,62.35s24.94-8.1,30.61-15C644.54,314.73,693.7,252,693.7,252L669,231.6,615,289.13l-32.51-44.77-28.34-2.66L536.88,257Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.16,294.64s.05-.09.18-.25l.59-.67,2.3-2.57,8.53-9.38,12.7-13.86,7.52-8.16c2.65-2.79,5.39-5.68,8.19-8.65l18.69-19.67.16-.16.17.14L687,246.25l5,4.21,1.31,1.13a3.43,3.43,0,0,1,.43.41,3.54,3.54,0,0,1-.48-.35l-1.36-1.07-5.07-4.11-17.91-14.69.33,0c-5.51,5.84-11.88,12.57-18.64,19.71l-8.2,8.65-7.55,8.14L622,282l-8.65,9.26-2.38,2.5-.63.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.48,254.17a10.31,10.31,0,0,1-1.54.55L603.7,256c-3.58,1.11-8.54,2.6-14,4.37l-4,1.32a30.92,30.92,0,0,0-3.61,1.34,9.32,9.32,0,0,0-4.47,4.46,17.7,17.7,0,0,0-1.27,4.2,11.7,11.7,0,0,1-.31,1.6,1.21,1.21,0,0,1,0-.43c0-.28,0-.68.11-1.2a16.09,16.09,0,0,1,1.13-4.33,9.56,9.56,0,0,1,4.6-4.73,29.25,29.25,0,0,1,3.66-1.39l4-1.34c5.44-1.77,10.42-3.2,14-4.22,1.81-.51,3.27-.9,4.29-1.17A8.74,8.74,0,0,1,609.48,254.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.42,225.37a2.49,2.49,0,0,1,.25-.48c.09-.16.2-.35.33-.55l.53-.71a19,19,0,0,1,4.15-3.77c3.89-2.75,10-5.36,17-7.29a94.3,94.3,0,0,1,18.2-3.19,49.73,49.73,0,0,1,5.61-.07c.66,0,1.17.09,1.52.14a2.51,2.51,0,0,1,.52.09c0,.05-.73,0-2.05,0s-3.22,0-5.57.24a103.63,103.63,0,0,0-18.09,3.32c-6.92,1.92-13,4.45-16.88,7.09a21,21,0,0,0-4.21,3.6l-.56.67-.37.52C519.55,225.23,519.44,225.38,519.42,225.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.51,309a2.08,2.08,0,0,1-.41-.27l-1.12-.87-4.09-3.22c-3.46-2.71-8.36-6.28-13.82-10.19a156,156,0,0,1-13.42-10.74c-1.62-1.49-2.92-2.71-3.79-3.58l-1-1a2,2,0,0,1-.32-.37s.15.09.4.3.64.55,1.06.93l3.9,3.44c3.32,2.89,8,6.69,13.49,10.6s10.34,7.53,13.74,10.32c1.7,1.4,3.07,2.54,4,3.35l1.06.94A2.08,2.08,0,0,1,568.51,309Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-part-1--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.05,
    cy: 258.49,
    rx: 80.4,
    ry: 25.66,
    transform: "translate(-126.46 334.63) rotate(-69.48)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.25,252.41c14.18-37.91,34.86-65.92,48.46-66.82a9,9,0,0,0-3.48-2.4c-13.27-5-36.65,24.72-52.21,66.31s-17.43,79.32-4.16,84.29a9.06,9.06,0,0,0,3.76.52C144.32,324.27,147.21,289.9,161.25,252.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,158.8s-3.54-9-5.07-12.29-1.2-13.25-.18-15.06a3.1,3.1,0,0,0,.08-3.19s-5.22-9.73-2.78-12.13l1.42-.16s5.23,10.44,5.41,10.65,1.32.26,1.68-1.56-.51-7.22-.51-7.22-2-3.44-2.13-5.8a3.84,3.84,0,0,1,1.45-2.67l.71-.55s4.39,7.94,4.64,9.88,1.05,6.15,1.05,6.15l.61-.49.05-9.74s-2.2-8.24-.53-10,1.83-.29,1.83-.29,3.14,8.41,3.37,10.54c.1.87.19,9.24.19,9.24l1.35-.56.47-7.82s-1.58-7.76.79-8.55l1.89-.06s1.8,10.21,2,10.69-1.38,12.13-1.38,12.13l.48,1.1,1.37-1.86a6.91,6.91,0,0,1,3.33-3.29c2.73-1.49,3.92-.41,3.92-.41l-3.42,6.08s-3.12,7.11-4.39,8.75a46.11,46.11,0,0,1-6.31,5.85c-.68.38.09,3.53.09,3.53l1.07,2.2Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,135c0,.11-1.1.08-2.8.49a13.08,13.08,0,0,0-9.5,8.77c-.54,1.66-.6,2.76-.7,2.75a6.73,6.73,0,0,1,.3-2.86,12.59,12.59,0,0,1,3.59-6c2.82-2.24,5.11-3.1,6.23-3.11A7.07,7.07,0,0,1,36,135Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.46,123.84c0,.2-4.11-.47-8.94.8s-8.13,3.77-8.23,3.6a8.22,8.22,0,0,1,2.12-1.64,21.6,21.6,0,0,1,12.4-3.18A8.56,8.56,0,0,1,36.46,123.84Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,158.8c.34.83,17.56,52.94,25,58.54s56.62,20,56.62,20l7.73-26.2L63.55,196.09l-29.86-50Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.83 203.99 77.69 197.66 69.75 229.96 112.72 239.79 114.83 203.99",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.16,206.56l-2.18-57c-.08-14.19-8.41-26-22.59-25.5l-1.31.12a25.36,25.36,0,0,0-23,25.54c.14,12.3.45,25.89,1.13,32.43,1.42,13.55,15.17,14.41,15.17,14.41s4.22,16.85,4.22,16.85l4.8,1.6h0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,196.59a32.93,32.93,0,0,0,17.18-6.85s-2.5,10.92-16.14,10.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87,160.78a1.93,1.93,0,0,0,2,1.78,1.85,1.85,0,0,0,1.83-1.92,2,2,0,0,0-2-1.79A1.86,1.86,0,0,0,95.87,160.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,155.48c.27.23,1.63-1,3.72-1.18s3.71.71,3.91.44-.19-.56-.9-1a5.39,5.39,0,0,0-3.16-.67,5.12,5.12,0,0,0-2.92,1.26C92.51,154.9,92.34,155.37,92.46,155.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,160.41c.26.23,1.63-1,3.72-1.18s3.7.72,3.91.44c.1-.12-.19-.55-.9-1a5.32,5.32,0,0,0-3.16-.66,5.15,5.15,0,0,0-2.93,1.25C112.39,159.83,112.21,160.31,112.34,160.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,170.78a13.49,13.49,0,0,0-3.44-.3c-.54,0-1-.07-1.17-.42a2.73,2.73,0,0,1,.21-1.61l1.2-4.2c1.65-6,2.8-10.86,2.56-10.92s-1.78,4.72-3.43,10.69c-.4,1.47-.78,2.87-1.14,4.22a3.09,3.09,0,0,0-.08,2.11,1.36,1.36,0,0,0,1,.7,3.63,3.63,0,0,0,.91,0A13.6,13.6,0,0,0,106.93,170.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,154.92c.33.51,2.3-.24,4.76-.51s4.54-.09,4.74-.66c.08-.27-.38-.72-1.28-1.07a8,8,0,0,0-3.73-.38,7.92,7.92,0,0,0-3.51,1.28C110.79,154.14,110.45,154.68,110.6,154.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,150.19c.47.44,2.13-.19,4.17-.37s3.8,0,4.16-.49c.15-.26-.16-.71-1-1.1a6.61,6.61,0,0,0-3.45-.52,6.53,6.53,0,0,0-3.26,1.21C92,149.46,91.76,150,92,150.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.79,159.73c.22-.12,9.07-3.61,9.62,5.68s-8.89,7.94-8.92,7.68S135.79,159.73,135.79,159.73Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.12,169.39s.17.11.45.22a1.65,1.65,0,0,0,1.21-.05c1-.42,1.69-2,1.64-3.71a5.42,5.42,0,0,0-.59-2.29,1.9,1.9,0,0,0-1.3-1.17.83.83,0,0,0-.93.5c-.11.27,0,.45-.08.47s-.21-.14-.16-.53a1.06,1.06,0,0,1,.33-.61,1.28,1.28,0,0,1,.88-.29,2.29,2.29,0,0,1,1.78,1.34,5.58,5.58,0,0,1,.72,2.56c.05,1.88-.8,3.69-2.13,4.16a1.73,1.73,0,0,1-1.49-.16C139.15,169.62,139.09,169.41,139.12,169.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.56,171.74c-.33,0-.23,2.13-2,3.73s-4,1.47-4,1.77c0,.14.53.4,1.49.38a5.33,5.33,0,0,0,3.39-1.36,4.61,4.61,0,0,0,1.52-3.12C114,172.24,113.7,171.72,113.56,171.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,138.46a2.21,2.21,0,0,1,1-1.35,6.84,6.84,0,0,1,3.45-.78,19.6,19.6,0,0,0,8.37-2.66,9.69,9.69,0,0,1-2.61-1.6,5.85,5.85,0,0,1-2-5.7,1.3,1.3,0,0,1,.68-.93c.59-.23,1.15.33,1.6.78a5.06,5.06,0,0,0,4.86,1.71,8.18,8.18,0,0,0,3.47-1.27l.1-.13c.46-.53.9-1,1.34-1.53h0c3.28-3.68,6.14-6.27,9.16-7.71,4.42-2.11,12-3.32,16.78-2.37s9.29,4.52,10.25,9.33c2.52-2.41,6.5-2.63,9.82-1.53l.07,0c3.68,1.06,6,4.73,7.25,8.34.07.2.14.4.2.59a14.37,14.37,0,0,0,5.14,4.44c.36.18.78.4.84.8a1.13,1.13,0,0,1-.56,1,7.16,7.16,0,0,1-2.83,1.4,15.82,15.82,0,0,0,1.35,2.45c.45.66,1,1.46.67,2.2a1.53,1.53,0,0,1-1.55.79,4.59,4.59,0,0,1-1.72-.66l1.38,2.81a8.42,8.42,0,0,1-3.93,0c-.55,3.48-.73,9.88-1.47,12.26-2.47.19-3.08,0-4.3.45-1.58.64-.79,3.45-2.93,2.77-1.1-.35-3-4.29-3.41-5.35a53.28,53.28,0,0,1-3.69-22.33,17.06,17.06,0,0,0-5.5-3.48l.17.14c-3.88-1.09-8.26-2.12-11.76-.11-2.71,1.56-4.18,4.56-6.12,7-3.7,4.63-8,7.25-13.93,7.87-.28,4.14,0,10.86,0,14.7l-3.74-7.46v0c-.29-.43-.54-.87-.78-1.31l-.08-.14h0c-.38-.71-.75-1.42-1.21-2.11l0,0a2.39,2.39,0,0,1-3.69-3,5.33,5.33,0,0,1,1.08-1.24,3.78,3.78,0,0,1-3.55,1.16,3,3,0,0,1-2.28-2.81,2.55,2.55,0,0,1,1.38-2.12,8.47,8.47,0,0,1-4.91-.76C70.38,140.53,69.39,139.69,69.64,138.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,126.08a12.36,12.36,0,0,1,1.44,1.16,9.85,9.85,0,0,1,2.37,4.39,17.29,17.29,0,0,1,.56,3.44c.08,1.25.06,2.6.06,4a34.24,34.24,0,0,0,.17,4.47,16.21,16.21,0,0,0,.45,2.33,5,5,0,0,0,1.1,2.22,2,2,0,0,0,2,.53,3,3,0,0,0,1.67-1.08,7.15,7.15,0,0,0,1.1-3.54l-.29,0a11.5,11.5,0,0,0,1.84,2.75,4,4,0,0,0,2.73,1.27,2.56,2.56,0,0,0,1.39-.33,2.2,2.2,0,0,0,.89-1,2.29,2.29,0,0,0,.22-1.22,1.71,1.71,0,0,0-.5-1l-.14.14a8.76,8.76,0,0,0,3.06,2c.4.15.71.24.93.3l.33.06a1.72,1.72,0,0,0-.32-.12,9,9,0,0,1-.9-.34,8.88,8.88,0,0,1-3-2.05l-.14.14a1.75,1.75,0,0,1,.22,2,2.08,2.08,0,0,1-.81.88,2.44,2.44,0,0,1-1.26.29,3.84,3.84,0,0,1-2.54-1.22,11.3,11.3,0,0,1-1.77-2.69l-.22-.43-.06.48a6.78,6.78,0,0,1-1.05,3.38,2.7,2.7,0,0,1-1.49,1,1.72,1.72,0,0,1-1.66-.44,4.61,4.61,0,0,1-1-2.09,13.93,13.93,0,0,1-.45-2.28,35.35,35.35,0,0,1-.19-4.43c0-1.42,0-2.77-.09-4a16.89,16.89,0,0,0-.61-3.48,9.73,9.73,0,0,0-2.49-4.42A5.74,5.74,0,0,0,121.82,126.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,141.92s0,0,.11.09l.36.22a3.87,3.87,0,0,0,.6.34,6.28,6.28,0,0,0,.85.38,12,12,0,0,0,5.89.69,15.44,15.44,0,0,0,8-3.54,26.58,26.58,0,0,0,6.55-8.57c.89-1.71,1.59-3.44,2.39-5.06a18,18,0,0,1,2.78-4.33,9.26,9.26,0,0,1,3.77-2.62,6.89,6.89,0,0,1,2.06-.37,7.4,7.4,0,0,1,1.91.25,7.88,7.88,0,0,1,4.6,3.43,9.45,9.45,0,0,1,.83,2s0,0,0-.14,0-.24-.09-.41a6.89,6.89,0,0,0-.61-1.5,7.82,7.82,0,0,0-1.65-2,8.23,8.23,0,0,0-3-1.61,7.4,7.4,0,0,0-2-.27,7,7,0,0,0-2.13.36,9.52,9.52,0,0,0-3.91,2.67,18.3,18.3,0,0,0-2.84,4.39c-.81,1.63-1.51,3.36-2.39,5.06a26.77,26.77,0,0,1-6.45,8.48,15.44,15.44,0,0,1-7.87,3.55,12.25,12.25,0,0,1-5.81-.58A18.48,18.48,0,0,1,80.55,141.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.94,136a2,2,0,0,0,.51.31,9.61,9.61,0,0,0,1.49.64,13.7,13.7,0,0,0,2.33.61,15.35,15.35,0,0,0,3,.21,16.13,16.13,0,0,0,2.93-.38,14.13,14.13,0,0,0,2.3-.75,10.62,10.62,0,0,0,1.45-.73,2.31,2.31,0,0,0,.49-.34c0-.05-.76.38-2,.86a14.84,14.84,0,0,1-2.27.67,15.85,15.85,0,0,1-5.77.17,15.31,15.31,0,0,1-2.31-.53C79.72,136.35,79,136,78.94,136Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,310.84l.94-4.5A99.21,99.21,0,0,1,151,285.43L101,234.79l1.3-14.53,24.64-23.07a30.69,30.69,0,0,1,27-1.76c17.3,6.86,24.63,16.57,44.82,40.11,8,9.33,3.51,1.53,11.34,6.59,0,0-4.91,26.67-14.2,43.2C189.06,297.43,180.38,310.84,180.38,310.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,240.17a14.68,14.68,0,0,1-1.84-2.57,67.79,67.79,0,0,1-3.73-6.67,69.4,69.4,0,0,1-3-7,16.37,16.37,0,0,1-.9-3,20.59,20.59,0,0,1,1.25,2.9c.74,1.8,1.8,4.27,3.1,6.94s2.6,5,3.57,6.71A22.22,22.22,0,0,1,106.15,240.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3,273.61a34.16,34.16,0,0,0-1.67-16.39c-3.14-8.18-11.25-19.68-11.25-19.68l-2.78,2.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150,323.89l18-47.16-9.5-11.86-17.92-22s-12.79-6.64-18.92-16.44a13,13,0,0,1-.28-12c5.6-10.58,17.2-14.78,28.74-11.61l10.16,6.65s33.53,52.56,33,62.68c-.38,7.16-28.65,55.58-28.65,55.58Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.26,321.89l-20,1.72a6.77,6.77,0,0,0-5.14,3.12l-9,14.13s3.57,1.66,5.93-1,6.18-8.2,6.18-8.2l-1.7,15.74s4.62.45,5.39-3.06a55.22,55.22,0,0,0,1-9.3l4.51,15s4.89-1.61,3.31-7.27c-1-3.57-2.06-7.24-2.06-7.24l5.49,9.73s4-.35,3-4c-.69-2.41-2.81-7.19-2.81-7.19s11.52.87,13.81,0c3.12-1.13,6.31-7.75,6.31-7.75Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,200.05s-16.79,9-15,21.64,16.28,19.2,16.28,19.2L153.61,261l29.5-25.63L156.27,202",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,202s0,0,.14.14l.39.45,1.47,1.77,5.51,6.75,19.51,24.08.15.18-.17.15-29.33,25.53-.15.12-.2.18-.17-.2-18.76-20.13.08.06a37.31,37.31,0,0,1-9.33-6.58,24.71,24.71,0,0,1-5.89-8.54c-.25-.79-.58-1.54-.75-2.33s-.36-1.55-.44-2.32a13.88,13.88,0,0,1,.22-4.48,18.58,18.58,0,0,1,3.4-7.12,35.86,35.86,0,0,1,8.15-7.63c1.07-.74,1.92-1.26,2.51-1.6l.67-.37c.15-.08.23-.11.24-.1l-.22.14-.65.41c-.57.36-1.41.9-2.46,1.66a36.3,36.3,0,0,0-8,7.68,18.22,18.22,0,0,0-3.29,7,13.4,13.4,0,0,0-.19,4.35c.08.75.3,1.5.45,2.27s.49,1.5.73,2.27c2.43,6,8.1,11.32,15,14.82l.05,0,0,0c5.81,6.21,12.16,13,18.78,20.11l-.37,0,.14-.13L183,235.2l0,.33c-8-10-14.66-18.32-19.36-24.21l-5.42-6.83-1.41-1.81c-.15-.2-.27-.35-.36-.48A1,1,0,0,1,156.27,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,325.75c0,.09-.65.07-1.64.35a6.43,6.43,0,0,0-4.73,5.68c-.1,1,0,1.66-.05,1.67a3.11,3.11,0,0,1-.32-1.69,6.19,6.19,0,0,1,5-6A3.09,3.09,0,0,1,135.62,325.75Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,328.1c0,.07-.39.36-1.07.85-.33.25-.73.54-1.13.9a3.36,3.36,0,0,0-1,1.31,7.76,7.76,0,0,0-.23,3.13,6.72,6.72,0,0,1,.13,1.35c-.06,0-.32-.45-.5-1.29a6.74,6.74,0,0,1,.11-3.37,3.67,3.67,0,0,1,1.2-1.5,9.72,9.72,0,0,1,1.24-.84C136.93,328.22,137.43,328,137.46,328.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,330a4,4,0,0,1-1.61.37c-1,.14-2.46.22-3.36,1.38a4.61,4.61,0,0,0-.87,3.53c.18.95.51,1.51.43,1.55a2.75,2.75,0,0,1-.79-1.47,4.65,4.65,0,0,1,.82-3.94,3.51,3.51,0,0,1,1.94-1.21,8.51,8.51,0,0,1,1.8-.21A7.9,7.9,0,0,1,145.83,330Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,325.75A33,33,0,0,1,156,324c-1.46-.56-2.77-1.09-3.71-1.48a10.15,10.15,0,0,1-1.5-.7c0-.21,2.48.58,5.4,1.69A30.1,30.1,0,0,1,161.38,325.75Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.34,236.7s-3.59,31.41-10.62,44.21-12.82,23.76-12.82,23.76l-.5,2.42s14.28-22.53,16.86-28.13a160.41,160.41,0,0,0,9.88-27.81c2.58-10.88,3-12.77,2.92-12.77S208,235.39,206.34,236.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.e1731d32b594e95a17ea2aec3e1df861.svg";
export { ForwardRef as ReactComponent };